<template>
  <v-dialog
    :value="value"
    max-width="1080"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    scrollable
    persistent
    @input="$emit('input', $event)"
  >
    <v-card class="ajuste-localizacao">
      <v-card-title class="d-flex align-start flex-nowrap">
        <div class="flex-grow-1 min-width-0">
          <div class="text-h6">Ajustar localização</div>
          <div v-if="endereco" class="text-body-2 texto-secundario">
            <strong>{{ endereco.cliente }}</strong>
            <span v-if="endereco.descricao"> · {{ endereco.descricao }}</span>
          </div>
          <div v-if="endereco" class="text-body-2 texto-secundario">
            {{ textoEndereco }}
          </div>
        </div>
        <v-btn icon aria-label="Fechar" @click="fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <div v-if="carregando" class="text-center py-12">
          <v-progress-circular indeterminate color="#5e72e4" />
        </div>
        <v-row v-else-if="endereco">
          <v-col cols="12" md="8">
            <div class="mapa-localizacao">
              <l-map
                ref="mapa"
                :zoom="zoom"
                :center="centro"
                :options="{ zoomControl: true }"
                @click="moverPara($event.latlng.lat, $event.latlng.lng)"
                @update:zoom="zoom = $event"
              >
                <l-tile-layer :url="tiles" :attribution="atribuicao" />
                <l-marker
                  v-if="base"
                  :lat-lng="[base.latitude, base.longitude]"
                  :icon="iconeBase"
                  :z-index-offset="-100"
                >
                  <l-tooltip>Base da filial</l-tooltip>
                </l-marker>
                <l-polyline
                  v-if="acessoDistinto"
                  :lat-lngs="[ponto, [acesso.latitude, acesso.longitude]]"
                  :color="corSituacao"
                  :dash-array="'6 6'"
                  :weight="3"
                />
                <l-circle-marker
                  v-if="acesso"
                  :lat-lng="[acesso.latitude, acesso.longitude]"
                  :radius="7"
                  color="#ffffff"
                  :fill-color="corSituacao"
                  :fill-opacity="1"
                  :weight="2"
                >
                  <l-tooltip>Ponto da via usado pelo roteirizador</l-tooltip>
                </l-circle-marker>
                <l-marker
                  v-if="ponto"
                  :lat-lng="ponto"
                  :icon="iconePino"
                  draggable
                  @dragend="
                    moverPara(
                      $event.target.getLatLng().lat,
                      $event.target.getLatLng().lng
                    )
                  "
                >
                  <l-tooltip>Arraste até a entrada do local</l-tooltip>
                </l-marker>
              </l-map>
            </div>
            <div class="text-caption texto-secundario mt-2">
              Clique no mapa ou arraste o marcador até o ponto onde o carro
              forte para: portaria, entrada ou vaga. O círculo mostra a via que
              o roteirizador vai usar.
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div
              class="situacao-localizacao"
              :style="{ borderColor: corSituacao }"
            >
              <div class="d-flex align-center">
                <v-icon :color="corSituacao" class="mr-2">{{
                  iconeSituacao
                }}</v-icon>
                <strong :style="{ color: corSituacao }">{{
                  tituloSituacao
                }}</strong>
                <v-progress-circular
                  v-if="verificando"
                  indeterminate
                  size="16"
                  width="2"
                  color="#5e72e4"
                  class="ml-2"
                />
              </div>
              <div class="text-body-2 mt-1">{{ detalheSituacao }}</div>
              <div v-if="sugerido" class="text-body-2 mt-2 texto-alerta">
                Ponto sugerido pela busca do endereço. Confira no mapa antes de
                salvar.
              </div>
              <div
                v-if="endereco && endereco.postoTrabalho"
                class="text-body-2 mt-2 texto-alerta"
              >
                Este endereço é local de posto de trabalho: a posição salva
                também define a cerca do ponto dos funcionários.
              </div>
              <v-btn
                v-if="acessoDistinto && podeEditar"
                small
                text
                class="text-none px-0 mt-1"
                color="#175cd3"
                @click="moverPara(acesso.latitude, acesso.longitude)"
              >
                <v-icon left small>mdi-map-marker-down</v-icon>Usar o ponto na
                via
              </v-btn>
            </div>

            <v-form class="mt-4" @submit.prevent="buscar">
              <v-text-field
                v-model="busca"
                label="Buscar endereço ou referência"
                placeholder="Ex.: Av. dos Holandeses, 100"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                hide-details
                :loading="buscando"
                @keydown.enter.prevent="buscar"
              />
            </v-form>
            <div v-if="erroBusca" class="text-caption mt-1 texto-alerta">
              {{ erroBusca }}
            </div>
            <v-list v-if="resultados.length" dense class="resultados-busca">
              <v-list-item
                v-for="(r, i) in resultados"
                :key="i"
                @click="escolherResultado(r)"
              >
                <v-list-item-content>
                  <v-list-item-title class="text-wrap text-body-2">{{
                    r.display_name
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-text-field
              v-model="coordenadasTexto"
              class="mt-4"
              label="Coordenadas (latitude, longitude)"
              hint="Cole aqui coordenadas copiadas de outro mapa."
              persistent-hint
              outlined
              dense
              :error-messages="erroCoordenadas"
              @change="aplicarCoordenadas"
            />
            <a
              v-if="ponto"
              :href="linkGoogle"
              target="_blank"
              rel="noopener"
              class="text-caption d-inline-block mt-2"
              ><v-icon x-small>mdi-open-in-new</v-icon> Conferir no Google Maps
              (satélite e Street View)</a
            >
          </v-col>
        </v-row>
        <div v-if="erro" class="mensagem-erro mt-3">
          <v-icon small color="#b42318" class="mr-1">mdi-alert-circle</v-icon
          >{{ erro }}
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-6 py-3">
        <span v-if="!podeEditar" class="text-caption texto-secundario"
          >Seu usuário pode consultar, mas não alterar endereços de
          clientes.</span
        >
        <v-spacer />
        <v-btn text class="text-none" @click="fechar">Cancelar</v-btn>
        <v-btn
          v-if="podeEditar"
          :disabled="!podeSalvar"
          :loading="salvando"
          class="
            font-weight-bold
            text-none
            btn-primary
            bg-gradient-primary
            px-6
          "
          @click="salvar"
          >Salvar localização</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import L from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LCircleMarker,
  LPolyline,
  LTooltip,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import DataService from "@/services/ComumDataService";

const url = "/roteirizador/localizacoes";
// Mesma malha viária (OpenStreetMap) usada pelo OSRM no cálculo das rotas. Para uso intenso,
// aponte VUE_APP_MAPA_TILES_URL para um servidor de mapas próprio ou contratado.
const TILES =
  process.env.VUE_APP_MAPA_TILES_URL ||
  "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
const SITUACOES = {
  OK: {
    cor: "#027a48",
    icone: "mdi-check-circle",
    titulo: "Localização com acesso pela via",
  },
  DISTANTE_DA_VIA: {
    cor: "#b54708",
    icone: "mdi-map-marker-alert",
    titulo: "Longe da via",
  },
  FORA_DO_RAIO: {
    cor: "#b42318",
    icone: "mdi-map-marker-distance",
    titulo: "Longe da base",
  },
  PROVISORIA: {
    cor: "#b42318",
    icone: "mdi-map-marker-question",
    titulo: "Localização provisória",
  },
  SEM_LOCALIZACAO: {
    cor: "#b42318",
    icone: "mdi-map-marker-off",
    titulo: "Sem localização",
  },
  NAO_CONFERIDA: {
    cor: "#475467",
    icone: "mdi-map-marker",
    titulo: "Acesso não conferido",
  },
};

export function coordenadasDoTexto(texto) {
  const partes = String(texto || "")
    .trim()
    .split(/[\s;,]+/)
    .filter(Boolean)
    .map(Number);
  if (partes.length !== 2 || partes.some((n) => !Number.isFinite(n)))
    return null;
  const [latitude, longitude] = partes;
  if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;
  return { latitude, longitude };
}

export function localizacaoValida(latitude, longitude) {
  return (
    Number.isFinite(latitude) &&
    Number.isFinite(longitude) &&
    Math.abs(latitude) <= 90 &&
    Math.abs(longitude) <= 180 &&
    !(Math.abs(latitude) <= 1 && Math.abs(longitude) <= 1)
  );
}

export function formatarDistancia(metros) {
  if (metros == null) return "";
  return metros < 1000
    ? `${Math.round(metros)} m`
    : `${(metros / 1000).toLocaleString("pt-BR", {
        maximumFractionDigits: 1,
      })} km`;
}

export default {
  name: "AjusteLocalizacaoEndereco",
  components: { LMap, LTileLayer, LMarker, LCircleMarker, LPolyline, LTooltip },
  props: {
    value: { type: Boolean, default: false },
    enderecoId: { type: Number, default: null },
  },
  data() {
    return {
      tiles: TILES,
      atribuicao:
        '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>',
      endereco: null,
      base: null,
      ponto: null,
      original: null,
      situacao: null,
      zoom: 17,
      carregando: false,
      verificando: false,
      salvando: false,
      erro: "",
      busca: "",
      buscando: false,
      resultados: [],
      erroBusca: "",
      coordenadasTexto: "",
      erroCoordenadas: "",
      verificacao: 0,
      sugerido: false,
      iconePino: L.divIcon({
        className: "pino-localizacao",
        html: '<span class="pino"></span>',
        iconSize: [30, 42],
        iconAnchor: [15, 42],
      }),
      iconeBase: L.divIcon({
        className: "base-localizacao",
        html: '<span class="mdi mdi-home-city"></span>',
        iconSize: [26, 26],
        iconAnchor: [13, 13],
      }),
    };
  },
  computed: {
    permissoes() {
      return this.$store.state.permissoes || [];
    },
    podeEditar() {
      return this.permissoes.includes("ROLE_Cliente_Update");
    },
    centro() {
      if (this.ponto) return this.ponto;
      if (this.base) return [this.base.latitude, this.base.longitude];
      return [-14.235, -51.925];
    },
    textoEndereco() {
      const e = this.endereco || {};
      const cidade = [e.cidade, e.uf].filter(Boolean).join("/");
      return [e.endereco, cidade, e.cep].filter(Boolean).join(" · ");
    },
    acesso() {
      return this.situacao && this.situacao.acesso;
    },
    acessoDistinto() {
      return (
        this.ponto &&
        this.acesso &&
        (this.situacao.distanciaViaMetros || 0) >= 5
      );
    },
    codigoSituacao() {
      return (this.situacao && this.situacao.situacao) || "SEM_LOCALIZACAO";
    },
    corSituacao() {
      return SITUACOES[this.codigoSituacao].cor;
    },
    iconeSituacao() {
      return SITUACOES[this.codigoSituacao].icone;
    },
    tituloSituacao() {
      return SITUACOES[this.codigoSituacao].titulo;
    },
    detalheSituacao() {
      const s = this.situacao || {};
      switch (this.codigoSituacao) {
        case "OK":
          return `A via mais próxima está a ${formatarDistancia(
            s.distanciaViaMetros || 0
          )}.`;
        case "DISTANTE_DA_VIA":
          return s.distanciaViaMetros == null
            ? "Não há via nas proximidades. Aproxime o marcador da entrada do local."
            : `A via mais próxima está a ${formatarDistancia(
                s.distanciaViaMetros
              )} (limite de ${formatarDistancia(
                s.limiteViaMetros
              )}). Aproxime o marcador da entrada do local.`;
        case "FORA_DO_RAIO":
          return `Está a ${formatarDistancia(
            (s.distanciaBaseKm || 0) * 1000
          )} da base, acima do raio de atendimento configurado. Confira se o ponto está na cidade certa.`;
        case "PROVISORIA":
          return "O cadastro tem uma coordenada de preenchimento. Marque o local no mapa.";
        case "NAO_CONFERIDA":
          return "O roteirizador não respondeu agora. O ponto pode ser salvo e será conferido no planejamento.";
        default:
          return "Marque no mapa o ponto de acesso do endereço.";
      }
    },
    alterado() {
      return (
        this.ponto &&
        (!this.original ||
          this.ponto[0] !== this.original[0] ||
          this.ponto[1] !== this.original[1])
      );
    },
    podeSalvar() {
      return (
        this.alterado &&
        !this.verificando &&
        localizacaoValida(this.ponto[0], this.ponto[1])
      );
    },
    linkGoogle() {
      return `https://www.google.com/maps/search/?api=1&query=${this.ponto[0]},${this.ponto[1]}`;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(aberto) {
        if (aberto && this.enderecoId) this.carregar();
      },
    },
  },
  methods: {
    async carregar() {
      this.carregando = true;
      this.erro = "";
      this.resultados = [];
      this.busca = "";
      this.sugerido = false;
      try {
        const { data } = await DataService.get(`${url}/${this.enderecoId}`);
        this.endereco = data;
        this.base = data.base || null;
        this.situacao = data;
        const valido = localizacaoValida(data.latitude, data.longitude);
        this.original = valido ? [data.latitude, data.longitude] : null;
        this.ponto = this.original ? [...this.original] : null;
        this.coordenadasTexto = this.ponto ? this.ponto.join(", ") : "";
        this.zoom = this.ponto ? 17 : 13;
        // Sem coordenada útil, sugere o ponto pela busca do endereço cadastrado.
        if (!this.ponto) {
          this.busca = this.textoEndereco.replace(/ · /g, ", ");
          this.buscar(true);
        }
      } catch (error) {
        this.erro = this.mensagem(error);
      } finally {
        this.carregando = false;
        this.$nextTick(() =>
          setTimeout(() => {
            const mapa = this.$refs.mapa && this.$refs.mapa.mapObject;
            if (!mapa) return;
            mapa.invalidateSize();
            // Enquadra o marcador e o acesso na via quando estão distantes.
            if (this.acessoDistinto)
              mapa.fitBounds(
                [this.ponto, [this.acesso.latitude, this.acesso.longitude]],
                { padding: [40, 40], maxZoom: 18 }
              );
          }, 250)
        );
      }
    },
    moverPara(latitude, longitude, centralizar = false) {
      if (!this.podeEditar) return;
      this.sugerido = false;
      this.ponto = [Number(latitude.toFixed(7)), Number(longitude.toFixed(7))];
      this.coordenadasTexto = this.ponto.join(", ");
      this.erroCoordenadas = "";
      this.verificar();
      // Busca e coordenadas coladas levam o mapa até o ponto; cliques mantêm a visão.
      if (centralizar)
        this.$nextTick(() => {
          const mapa = this.$refs.mapa && this.$refs.mapa.mapObject;
          if (mapa) mapa.setView(this.ponto, this.zoom);
        });
    },
    async verificar() {
      const token = ++this.verificacao;
      this.verificando = true;
      try {
        const { data } = await DataService.post(`${url}/verificacao`, {
          latitude: this.ponto[0],
          longitude: this.ponto[1],
        });
        if (token === this.verificacao) this.situacao = data;
      } catch (error) {
        if (token === this.verificacao)
          this.situacao = { situacao: "NAO_CONFERIDA" };
      } finally {
        if (token === this.verificacao) this.verificando = false;
      }
    },
    aplicarCoordenadas() {
      const coordenadas = coordenadasDoTexto(this.coordenadasTexto);
      if (!coordenadas) {
        this.erroCoordenadas = "Use o formato -2.5301, -44.2989.";
        return;
      }
      this.zoom = 17;
      this.moverPara(coordenadas.latitude, coordenadas.longitude, true);
    },
    async buscar(sugestao = false) {
      if (!this.busca || this.buscando) return;
      this.buscando = true;
      this.erroBusca = "";
      try {
        // Nominatim (OpenStreetMap): uma consulta por ação do usuário, restrita ao Brasil.
        const params = new URLSearchParams({
          format: "jsonv2",
          countrycodes: "br",
          limit: "5",
          "accept-language": "pt-BR",
          q: this.busca,
        });
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?${params}`
        );
        if (!response.ok) throw new Error();
        this.resultados = await response.json();
        if (!this.resultados.length)
          this.erroBusca =
            "Nada encontrado. Tente rua e número, ou um ponto de referência.";
        else if (sugestao) {
          this.escolherResultado(this.resultados[0]);
          this.sugerido = true;
        }
      } catch (error) {
        this.erroBusca =
          "A busca não respondeu. Navegue pelo mapa e clique no local.";
      } finally {
        this.buscando = false;
      }
    },
    escolherResultado(resultado) {
      this.resultados = [];
      this.zoom = 18;
      this.moverPara(Number(resultado.lat), Number(resultado.lon), true);
    },
    async salvar() {
      this.salvando = true;
      this.erro = "";
      try {
        const { data } = await DataService.put(`${url}/${this.enderecoId}`, {
          latitude: this.ponto[0],
          longitude: this.ponto[1],
        });
        this.$emit("salvo", data);
        this.$emit("input", false);
      } catch (error) {
        this.erro = this.mensagem(error);
      } finally {
        this.salvando = false;
      }
    },
    fechar() {
      this.$emit("input", false);
    },
    mensagem(error) {
      const data = error && error.response && error.response.data;
      return (
        (data && (data.message || data.msg)) ||
        "Não foi possível concluir. Tente novamente."
      );
    },
  },
};
</script>

<style scoped>
.mapa-localizacao {
  height: 460px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e4e7ec;
}
.texto-secundario {
  color: #475467;
}
.texto-alerta {
  color: #b54708;
}
.min-width-0 {
  min-width: 0;
}
.situacao-localizacao {
  border-left: 4px solid;
  background: #f9fafb;
  border-radius: 6px;
  padding: 12px 14px;
}
.resultados-busca {
  border: 1px solid #e4e7ec;
  border-radius: 6px;
  max-height: 220px;
  overflow-y: auto;
}
.mensagem-erro {
  color: #b42318;
  background: #fef3f2;
  border-radius: 6px;
  padding: 8px 12px;
}
.ajuste-localizacao ::v-deep .pino-localizacao .pino {
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 50% 50% 50% 0;
  background: #5e72e4;
  border: 3px solid #ffffff;
  box-shadow: 0 2px 6px rgba(16, 24, 40, 0.4);
  transform: rotate(-45deg);
}
.ajuste-localizacao ::v-deep .base-localizacao span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #344054;
  color: #ffffff;
  font-size: 15px;
}
@media (max-width: 960px) {
  .mapa-localizacao {
    height: 340px;
  }
}
</style>
